import WhatsNew from './components/WhatsNewView'
export default class WhatsNewRoute {
  constructor (store) {
    this.path = '/releaseNotes'
    this.component = WhatsNew
  }
}
